// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__hPl62 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}
@media (min-width: 768px) {
  .styles_container__hPl62 {
    gap: 32px;
  }
}

.styles_coursesList__RyG20 {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 420px;
  overflow-y: auto;
  padding-right: 8px;
}
@media (min-width: 768px) {
  .styles_coursesList__RyG20 {
    margin-top: 8px;
    gap: 24px;
    max-height: 450px;
  }
}
.styles_coursesList__RyG20::-webkit-scrollbar {
  width: 6px;
}
.styles_coursesList__RyG20::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.styles_coursesList__RyG20.styles_singleCourse__6NMj4 {
  overflow-y: visible;
}

.styles_confirmActions__RenxZ {
  width: 100%;
  display: flex;
  justify-content: center;
}
@media (min-width: 768px) {
  .styles_confirmActions__RenxZ {
    margin-top: 8px;
  }
}

.styles_confirmButton__moVLn {
  min-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/screens/select-sections/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAAF;ACCE;EDNF;IAQI,SAAA;EACF;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AACF;ACdE;EDMF;IAUI,eAAA;IACA,SAAA;IACA,iBAAA;EAEF;AACF;AAAE;EACE,UAAA;AAEJ;AACE;EACE,oCAAA;EACA,kBAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AADF;ACrCE;EDmCF;IAMI,eAAA;EAAF;AACF;;AAGA;EACE,gBAAA;AAAF","sourcesContent":["@import \"mixins\";\n.container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n\n  @include md {\n    gap: 32px;\n  }\n}\n\n.coursesList {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-height: 420px;\n  overflow-y: auto;\n  padding-right: 8px;\n\n  @include md {\n    margin-top: 8px;\n    gap: 24px;\n    max-height: 450px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n  }\n\n  &.singleCourse {\n    overflow-y: visible;\n  }\n}\n\n.confirmActions {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n\n  @include md {\n    margin-top: 8px;\n  }\n}\n\n.confirmButton {\n  min-width: 200px;\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__hPl62`,
	"coursesList": `styles_coursesList__RyG20`,
	"singleCourse": `styles_singleCourse__6NMj4`,
	"confirmActions": `styles_confirmActions__RenxZ`,
	"confirmButton": `styles_confirmButton__moVLn`
};
export default ___CSS_LOADER_EXPORT___;
